import { useState } from 'react';

import { Text } from '../../../cdl/Text/Text';
import { translate } from '../../../common/helpers/translate.helper';
import { Box } from '../../../common/ui/Box';
import { OfferModel } from '../../../offer/model/OfferModel';
import { RfqOfferCard } from '../../../order/detail/components/RfqOfferCard/RfqOfferCard';

interface QuotedOffersListProps {
    offers: OfferModel[];
    isMultipleOffersEnabled: boolean;
}

export const RfqOfferList = ({ offers, isMultipleOffersEnabled }: QuotedOffersListProps) => {
    const hasOnlyOneOffer = offers.length === 1;
    const onlyOfferIsUnquoted = hasOnlyOneOffer && !offers[0].wasQuoted();

    const [expandedOfferId, setExpandedOfferId] = useState<string | null>(
        !isMultipleOffersEnabled && offers[0] ? offers[0].id : null
    );

    if (onlyOfferIsUnquoted) {
        return (
            <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                gap={8}
                height="145px"
                width="100%"
                border="1px dashed"
                borderColor="border.muted"
                borderRadius={8}
            >
                <Text variant="fieldLabel" color="foreground.subtle">
                    {translate('rfq.detail.noQuotes.title')}
                </Text>

                <Text variant="small" color="foreground.subtle">
                    {translate(
                        isMultipleOffersEnabled
                            ? 'rfq.detail.noQuotes.multipleOffersDescription'
                            : 'rfq.detail.noQuotes.description'
                    )}
                </Text>
            </Box>
        );
    }

    return (
        <Box display="flex" flexDirection="column" gap={16}>
            {offers.map((offer) => (
                <RfqOfferCard
                    key={offer.id}
                    offer={offer}
                    expanded={expandedOfferId === offer.id}
                    onClick={() => setExpandedOfferId(expandedOfferId === offer.id ? null : offer.id)}
                />
            ))}
        </Box>
    );
};
